module.exports = __webpack_public_path__ + "img/porsche-911-gt2-rs.0fba4aab.jpg";